<template>
  <div class="tabClass">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :key="1" :label="$t('uploadFile.customerLeadTime')" name="customerTime">
        <customerTime v-if="isShow1" />
      </el-tab-pane>
      <el-tab-pane :key="0" :label="$t('uploadFile.regionLeadTime')" name="regionalTimeliness">
        <regionalTimeliness v-if="isShow" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'ExpressDeliveryMonitoring',
  components: {
    customerTime: () => import('./components/customerTime.vue'),
    regionalTimeliness: () => import('./components/regionalTimeliness.vue')
  },
  data() {
    return {
      activeName: 'customerTime',
      noRouteAssociated: 0,
      isShow: false,
      isShow1: true
    };
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'regionalTimeliness') {
        this.isShow1 = false;
        this.isShow = true;
      }
      if (tab.name === 'customerTime') {
        this.isShow = false;
        this.isShow1 = true;
      }
    }
  }
};
</script>

<style scoped>
.tabClass {
  padding: 0 10px;
}
</style>
